// extracted by mini-css-extract-plugin
module.exports = {"separator":"separator-module--separator--184hh","color":"separator-module--color--1juGs"};